import React from 'react';

const positions = ['Left', 'Centre', 'Right'];

// Single TV-screen with three clickable position dots (L, C, R)
// The active dot uses the igloo's color (passed via the color prop)
// value: null | "Left" | "Centre" | "Right"
// onChange: (newPosition) => void — null means deselect
// color: { dot, dotHover } from iglooColors palette
// disabled: boolean
// autoMode: boolean — if true, only Centre is clickable
function PositionSelector({ value, onChange, color, disabled = false, autoMode = false }) {
  const handleDotClick = (posKey) => {
    if (disabled) return;
    if (autoMode && posKey !== 'Centre') return;

    if (value === posKey) {
      onChange(null);
    } else {
      onChange(posKey);
    }
  };

  return (
    <div className={`
      inline-flex items-center justify-center
      w-20 h-12 rounded-lg border-2 relative
      ${disabled ? 'bg-slate-50 border-slate-200 opacity-40' : 'bg-slate-50 border-slate-300'}
    `}>
      {/* Three dots inside the screen */}
      <div className="flex items-center gap-2.5">
        {positions.map((posKey) => {
          const isActive = value === posKey;
          const isDotDisabled = disabled || (autoMode && posKey !== 'Centre');

          return (
            <button
              key={posKey}
              onClick={(e) => { e.stopPropagation(); handleDotClick(posKey); }}
              disabled={isDotDisabled}
              className={`
                w-3.5 h-3.5 rounded-full border-2 transition-all
                ${isActive
                  ? (color ? color.dot : 'bg-slate-500 border-slate-500')
                  : isDotDisabled
                    ? 'bg-slate-200 border-slate-200 cursor-not-allowed'
                    : `bg-slate-200 border-slate-300 cursor-pointer ${color ? color.dotHover : 'hover:bg-slate-300 hover:border-slate-400'}`
                }
              `}
              title={isDotDisabled && autoMode && posKey !== 'Centre'
                ? 'Auto Mode: only Centre available'
                : posKey
              }
            />
          );
        })}
      </div>
      {/* TV stand */}
      <div className="absolute -bottom-1.5 left-1/2 transform -translate-x-1/2 w-4 h-1.5 bg-slate-300 rounded-b-sm"></div>
    </div>
  );
}

export default PositionSelector;
